import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useRef, useState } from 'react';
import ReactResizeDetector from 'react-resize-detector/build/withPolyfill';
import TruncateMarkup from 'react-truncate-markup';
import { Z_INDEX_TOP } from '../../../../define/consts/style';
import { propStr } from '../../../../helpers/custom-prop-types';
import Tooltip from '../../../Ui/Tooltip/Tooltip';
const ProfessionalUnitExperiencedListItem = (props) => {
    const { className, text, textClassName } = props;
    const truncateRef = useRef();
    const [isTruncated, changeIsTruncated] = useState(false);
    const onResize = useCallback(() => {
        if (!truncateRef.current) {
            return;
        }
        const { clientHeight, scrollHeight } = truncateRef.current.el || {};
        if (scrollHeight > clientHeight) {
            changeIsTruncated(true);
        }
    }, [truncateRef, changeIsTruncated]);
    return (_jsx("li", Object.assign({ className: clsx('experienced_list_item experienced_tile', className) }, { children: _jsx(ReactResizeDetector, Object.assign({ onResize: onResize, targetRef: truncateRef }, { children: _jsx(Tooltip, Object.assign({ className: textClassName, disabled: !isTruncated, html: text, zIndex: Z_INDEX_TOP }, { children: _jsx(TruncateMarkup, Object.assign({ lines: 1, onTruncate: changeIsTruncated, ref: truncateRef }, { children: _jsx("div", { children: text }) })) })) })) })));
};
ProfessionalUnitExperiencedListItem.propTypes = {
    className: propStr(),
    text: propStr().isRequired,
    textClassName: propStr(),
};
ProfessionalUnitExperiencedListItem.defaultProps = {
    className: '',
    textClassName: '',
};
export default ProfessionalUnitExperiencedListItem;
